import React, { FC } from 'react'
import styles from './MapLayerMenu.module.scss'
import { useTranslation } from 'react-i18next'
import { Tooltip } from 'components/Tooltip'

type MapLayerMenuProps = {
  saveClipped: any
  project: any
}

export const MapLayerMenu: FC<MapLayerMenuProps> = ({ saveClipped, project }) => {
  const { t } = useTranslation()

  const buttonStyles = {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    width: '30px',
    height: '30px',
    border: 'none',
    background: 'none',
    backgroundColor: '#fff',
    padding: '0',
    cursor: 'pointer',
  }

  const buttonContainerStyles = {
    cursor: 'pointer',
    backgroundColor: '#fff',
  }

  return (
    <div className={styles.mapLayerMenu} style={buttonContainerStyles}>
      {localStorage.getItem('clipped') === 'true' && (
        <React.Fragment>
          {project && (
            <button onClick={saveClipped} style={buttonStyles}>
              <Tooltip label={t('map.tools.map_visualization.full_layer')} direction="LEFT_CENTER">
                <img
                  src="https://report.descifra.global/ImagenesCarto/icono_encendido.svg"
                  alt="mostrar capa"
                  width="100%"
                ></img>
              </Tooltip>
            </button>
          )}
        </React.Fragment>
      )}

      {localStorage.getItem('clipped') === 'false' && (
        <React.Fragment>
          {project && (
            <button onClick={saveClipped} style={buttonStyles}>
              <Tooltip
                label={t('map.tools.map_visualization.deactivate_full_layer')}
                direction="LEFT_CENTER"
              >
                <img
                  src="https://report.descifra.global/ImagenesCarto/icono_apagado.svg"
                  alt="mostrar capa"
                  width="100%"
                ></img>
              </Tooltip>
            </button>
          )}
        </React.Fragment>
      )}
    </div>
  )
}

MapLayerMenu.displayName = 'MapLayerMenu'
